import api from "./api";
import store from "@/store";

// Sai do sistema: pede ao servidor para invalidar o token de acesso e o de
// renovação (antes só limpava o navegador e o refresh token continuava
// válido por 7 dias). Se o servidor não responder, sai do mesmo jeito.
export async function sair() {
  let refreshToken = null;
  try {
    refreshToken = localStorage.getItem("refreshToken");
  } catch {
    // sem acesso ao armazenamento: só limpa a sessão
  }
  try {
    await api.delete("/logout", { data: { refresh_token: refreshToken } });
  } catch {
    // offline ou token já expirado: o logout local continua
  }
  store.commit("CLEAR_AUTH");
}
